// extracted by mini-css-extract-plugin
module.exports = {"Page":"Layout_Page__5M2rM","Header":"Layout_Header__2pt-3","Content":"Layout_Content__3jInt"};